// POS Management Permissions
export const POS_CREATE = 207;
export const POS_UPDATE = 208;
export const POS_DELETE = 209;
export const POS_INDEX = 210;
export const POS_RESTORE = 1410;
